import { render } from "./about.vue?vue&type=template&id=ebf448d2"
import script from "./about.js?vue&type=script&lang=js"
export * from "./about.js?vue&type=script&lang=js"

import exportComponent from "/woodpecker/src/akkoma.dev/AkkomaGang/akkoma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__